export enum OrderPlacedState {
  Success = 'success',
  Warning = 'warning',
  Canceled = 'canceled',
  IncompleteFinished = 'incompleteFinished',
  IncompleteUnfinished = 'incompleteUnfinished',
  ECommercePaymentDenied = 'eCommercePaymentDenied',
  ECommercePaymentPending = 'eCommercePaymentPending',
}

export enum PaymentStatus {
  Success = 'success',
  Canceled = 'canceled',
  OrderCreated = 'order-created',
  OnOrderCompleted = 'on-order-completed',
  PaymentPending = 'payment-pending',
  WaitingForOrderAuthorization = 'waiting-for-order-authorization',
  Cancelled = 'cancelled',
  RequestCancel = 'request-cancel',
  WaitingForSellerDecision = 'waiting-for-seller-decision',
  CancellationRequested = 'cancellation-requested',
  Cancel = 'cancel',
  Invoiced = 'invoiced',
  ReadyForHandling = 'ready-for-handling',
  PaymentApproved = 'payment-approved',
  OrderCompleted = 'order-completed',
  Handling = 'handling',
  OrderCreateError = 'order-create-error',
  OrderCreationError = 'order-creation-error',
  PaymentDenied = 'payment-denied',
}

export type ListOrdersQueryParams = {
  after?: string
  before?: string
  first?: number
  last?: number
  query?: string
}

export type ListOrdersQueryResult = {
  orders: {
    edges: Array<{
      cursor: string
      node: {
        orderId: string
        creationDate: string
        clientName: string
        totalValue: number
        callCenterOperatorName: string
        currencyCode: string
      }
    }>
    pageInfo: {
      endCursor: string
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor: string
    }
    totalCount: number
  }
}

export type CancelOrderMutationParams = {
  cancelOrderId: string
}

export type CancelOrderMutationResult = {
  date: string
  orderId: string
  receipt: string | null
}
